module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.10766/images/homepage/company-logos-es/Casio_Logo.png"